// @flow
import * as AppDataAction from './app_data'
import * as AppSettingAction from './app_settings'
import * as PagesActions from './pages';
import * as ParentPagesActions from './parent_pages';
import * as PreOrderPagesActions from './pre_order_pages';
import * as WidgetsActions from './widgets';
import * as PlanActions from './plan';
import * as AppEditedActions from './app_edited';
import * as AppRenderActions from './app_render';
import * as WidgetSelectedActions from './widget_selected';
import * as LayoutMailDataAction from './layout_mail';
import * as LayoutReminderMailDataAction from './layout_reminder_mail';
import * as PagesConfigAction from './pages_config';
import * as CompareCustomAction from './compare_custom';

const AppNotify = (notifyObject: Object): Object => {
    return {
        type: 'NOTIFICATION',
        notifyObject,
    }
}

const Actions = {
    ...AppDataAction,
    ...AppSettingAction,
    AppNotify,
    ...PagesActions,
    ...WidgetsActions,
    ...AppRenderActions,
    ...AppEditedActions,
    ...LayoutMailDataAction,
    ...WidgetSelectedActions,
    ...WidgetSelectedActions,
    ...PlanActions,
    ...LayoutReminderMailDataAction,
    ...ParentPagesActions,
    ...PreOrderPagesActions,
    ...PagesConfigAction,
    ...CompareCustomAction
    //...AnotherAction,
}

export default Actions;